module.exports = {"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 157
// module chunks = 60335399758886 114276838955818